export const LOCAL_STORAGE_KEYS = {
    TOKEN: 'poseidon-appToken',
    USER_COMPANY: 'poseidon-user-company'
}